import React from "react";
import "./CapitalStructure.scss";
import useAboutUs from "../../../hooks/useAboutUs";
import capitalStructureBg from "../../../assets/About/capital-structure-bg.png";
import lightImg from "../../../assets/About/capital-image.png";

const CapitalStructure = () => {
  const [aboutUs, setAboutUs] = useAboutUs();

  let capitalStData = aboutUs.filter(
    (csData) => csData.DescType === "CAPITAL STRUCTURE"
  );

  // console.log("capital Structure Data", capitalStData);

  return (
    <>
      <div className="capital_structure">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${capitalStructureBg})` }}
            data-aos="zoom-in"
          ></div>
          <div className="heading_box">{capitalStData[0]?.Title}</div>
        </div>

        <div className="container">
          <div className="capital_content">
            <div className="row">
              <div className="col-lg-6 my-auto">
                <div className="left">
                  <h4>{capitalStData[0]?.Title}</h4>
                </div>
              </div>
              <div className="col-lg-6">
                <img src={lightImg} className="img-fluid" alt="" />
              </div>
              <p>{capitalStData[0]?.Description}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CapitalStructure;
